<template>
  <div v-if="banners">
    <b-modal
      v-if="currentNotif"
      id="notif-modal"
      ref="notifModal"
      hide-footer
      centered
      size="md"
      class="p-0"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @hidden="onModalHidden"
    >
      <div class="d-flex flex-column gap-2 py-1 pr-2">
        <img
          :src="currentNotif.media_url"
          alt="media"
          max-width="300px"
        >
        <div class="d-flex flex-column mt-1">
          <h6 class="font-bold text-black text-xl">
            {{ currentNotif.title }}
          </h6>
          <div class="d-flex gap-2">
            <span class="text-black">
              {{ currentNotif.description }}
              <strong class="font-bold">
                <a
                  :href="currentNotif.url_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-black text-decoration-none"
                >
                  {{ currentNotif.url_link }}
                </a>
              </strong>
            </span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { komshipAxiosIns } from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'

export default {
  data() {
    return {
      currentIndex: 0,
      banners: [],
    }
  },
  computed: {
    currentNotif() {
      return this.banners[this.currentIndex] || null
    },
  },
  mounted() {
    const token = useJwt.getToken()
    if (!token) return
    this.$store.dispatch('notification/fetchNotifications', komshipAxiosIns).then(() => {
      const allBanners = this.$store.getters['notification/banners']
      this.banners = allBanners.filter(b => !this.isDismissed(b.id))
      this.showCurrentModal()
    })
  },
  methods: {
    getDismissedBanners() {
      const dismissed = localStorage.getItem('dismissedBanners')
      return dismissed ? JSON.parse(dismissed) : []
    },

    isDismissed(id) {
      return this.getDismissedBanners().includes(id)
    },

    saveDismissedBanner(id) {
      const dismissed = this.getDismissedBanners()
      if (!dismissed.includes(id)) {
        dismissed.push(id)
        localStorage.setItem('dismissedBanners', JSON.stringify(dismissed))
      }
    },
    showCurrentModal() {
      if (this.currentNotif) {
        this.$nextTick(() => {
          this.$bvModal.show('notif-modal')
        })
      }
    },
    onModalHidden() {
      if (this.currentNotif) {
        this.$store.dispatch('notification/dismissBanner', this.currentNotif.id)

        this.saveDismissedBanner(this.currentNotif.id)
      }

      // eslint-disable-next-line no-plusplus
      this.currentIndex++
      setTimeout(() => {
        this.showCurrentModal()
      }, 300)
    },
  },
}
</script>
